import { Navigate, useSearchParams, type RouteObject } from "react-router-dom";
import { TAB_QUERY_PARAM } from "./custom-reports-constants";
import { CustomReportsTab } from "./custom-reports-types";

const CustomReportsTabs = [
  CustomReportsTab.Overview,
  CustomReportsTab.Reports,
  CustomReportsTab.Debug,
  CustomReportsTab.Catalog,
  CustomReportsTab.Relationships,
] as const;
const CustomReportsTabValues: readonly string[] = CustomReportsTabs;

const customReportsBreadcrumbs: Record<CustomReportsTab, string> = {
  [CustomReportsTab.Overview]: "Overview",
  [CustomReportsTab.Reports]: "Reports",
  [CustomReportsTab.Debug]: "Debug",
  [CustomReportsTab.Catalog]: "Semantic Catalog",
  [CustomReportsTab.Relationships]: "Relationship Explorer",
};

function isCustomReportsTab(value: string | null): value is CustomReportsTab {
  return value !== null && CustomReportsTabValues.includes(value);
}

function CustomReportsIndexRedirect() {
  const [searchParams] = useSearchParams();
  const tab = searchParams.get(TAB_QUERY_PARAM);
  const targetTab = isCustomReportsTab(tab) ? tab : CustomReportsTab.Overview;
  const nextSearchParams = new URLSearchParams(searchParams);
  nextSearchParams.delete(TAB_QUERY_PARAM);
  const search = nextSearchParams.toString();

  return <Navigate replace to={`${targetTab}${search ? `?${search}` : ""}`} />;
}

function customReportsTabRoute(tab: CustomReportsTab): RouteObject {
  return {
    path: tab,
    handle: { breadcrumb: customReportsBreadcrumbs[tab] },
    async lazy() {
      const { CustomReportsPage } = await import("./custom-reports-page");
      return { element: <CustomReportsPage tab={tab} /> };
    },
  };
}

export const customReportsRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Analytics" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page hidePadding={() => true} /> };
    },
    children: [
      { index: true, element: <CustomReportsIndexRedirect /> },
      ...CustomReportsTabs.map(customReportsTabRoute),
    ],
  },
];
